// ParentPage.jsx
import React, { useState, useEffect } from 'react';
import { View } from '@instructure/ui-view';
import { Flex } from '@instructure/ui-flex';
import { Text } from '@instructure/ui-text';
import { Stack } from '@mui/material';
import Export from '../components/Export';
import Search from '../components/Search';
import { TextInput } from '@instructure/ui-text-input';
import { Dropdown } from '../components/Dropdown';
import { ResetButton } from '../components/ResetButton';
import { TableComponent } from '../components/TableNew';
import { PERPAGE } from '../utils/constants';

import { API_DATA_PARENT } from '../utils/dummyData';

export default function ParentPage() {
    const [rows, setRows] = useState([]);
    const [headers, setHeader] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedClass, setSelectedClass] = useState({ id: 0, name: 'Toàn trường' });
    const [searchData, setSearchData] = useState(null);
    const [searchString, setSearchString] = useState("");
    const [isReset, setIsReset] = useState(false);
    const [placeholder, setPlaceholder] = useState("Tìm kiếm theo tên học sinh");
  
    useEffect(() => {
      localStorage.removeItem('token');

      setIsLoading(true);
      setIsReset(false);
      const queryParameters = new URLSearchParams(window.location.search);
      const token = queryParameters.get('jwt');
      localStorage.setItem('token', token);
      if (!queryParameters.get('jwt')) {
        setIsLoading(false);
        return;
    }


      // let token = localStorage.getItem('token');
      // if (!token) {
      //   const queryParameters = new URLSearchParams(window.location.search);
      //   if (!queryParameters.get('jwt')) {
      //     setIsLoading(false);
      //     return;
      //   }
      //   localStorage.setItem('token', queryParameters.get('jwt'));
      // } else {
      //   const queryParameters = new URLSearchParams(window.location.search);
      //   if (queryParameters.get('jwt')) {
      //     localStorage.setItem('token', queryParameters.get('jwt'));
      //   }
      // }
  
      const query = selectedClass?.id == 0 ? 'moet/parents' : `moet/classes/${selectedClass?.id}/parents`;
    
    if (selectedClass?.id) {
      fetch(`/api/v1/${query}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((apiData) => {
          if (selectedClass) {
            setRows(apiData);
            setHeader([
              // { id: 'MA_HOC_SINH', text: 'Mã học sinh', width: '0px' ,hide: true},
              { id: 'HO_TEN', text: 'Họ và tên', width: '250px' },
              { id: 'NGAY_SINH', text: 'Ngày sinh', width: '150px' },
              { id: 'MA_LOP', text: 'Lớp', width: '100px' },
              { id: 'username', text: 'Tên tài khoản', width: '150px' },
              { id: 'default_password', text: 'Mật khẩu mặc định', width: '150px' },
            ]);
          }
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
    }, [selectedClass, isReset]);
  
    function search(event, value) {
      value = value.toLowerCase();
      setSearchString(value);
      const filteredData = rows.filter((row) => row.HO_TEN.toLowerCase().includes(value));
      setSearchData(filteredData);
    }
  
    function renderDropDown() {
      return <TextInput placeholder={placeholder} onChange={search} />;
    }
  
    return (
      <View as="div" margin="small" padding="large" background="primary">
        <Export />
        <Search search={search} placeholder={placeholder} renderDropDown={renderDropDown} />
        <Stack direction="row" spacing={2} sx={{ paddingTop: '20px' }}>
          <Dropdown
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            selectedClass={selectedClass}
            setSelectedClass={setSelectedClass}
          />
        </Stack>
        <Stack spacing={2} sx={{ paddingTop: '20px' }}>
          <ResetButton
            setSelectedIds={setSelectedIds}
            selectedClass={selectedClass}
            selectedIds={selectedIds}
            disableButton={selectedIds.length === 0}
            setSelectedClass={setSelectedClass}
            setIsReset={setIsReset}
            type="parent"
          />
        </Stack>
        {selectedClass ? (
          isLoading ? (
            <Flex justifyItems="center" margin="large">
              <Flex.Item>
                <Text>Đang tải dữ liệu</Text>
              </Flex.Item>
            </Flex>
          ) : (
            <>
              {rows.length <= 0 ? (
                <Flex justifyItems="center" margin="large">
                  <Flex.Item>
                    <Text>Không có dữ liệu</Text>
                  </Flex.Item>
                </Flex>
              ) : (
                <TableComponent
                  headers={headers}
                  rows={searchData ? searchData : rows}
                  perPage={PERPAGE}
                  selectedIds={selectedIds}
                  setSelectedIds={setSelectedIds}
                />
              )}
            </>
          )
        ) : (
          <Flex justifyItems="center" margin="large">
            <Flex.Item>
              <Text>Vui lòng chọn lớp</Text>
            </Flex.Item>
          </Flex>
        )}
      </View>
    );
  }
  